module.exports = __webpack_public_path__ + "img/nose-04.01a94744.svg";